import {
    initMain
} from "./vue/controllers/main";

initMain([], {
    RegisterEventForm: () => import('./vue/components/register-event-form/RegisterEventForm.vue')
}, []);